/**
 * @function 延迟函数
 * @param second {number} 延迟间隔
 * @returns {Promise<any>}
 * @private
 */
function _delay(second = 1000) {
  // 延迟second
  return new Promise((resolve) => {
    setTimeout(function () {
      resolve()
    }, second)
  })
}

/**
 * @function 递归函数
 * @param promise {Promise<any>}
 * @param resolve
 * @param reject
 * @param count {number} 第几次请求
 * @param totalCount {number} 请求次数
 * @param params {object} 请求参数
 * @private
 */
function _recursion(promise, resolve, reject, count, totalCount, params) {
  console.log(`请求重试，第${count}次重试`);
  _delay().then(() => {
    promise(params).then((res) => {
      console.log(`请求成功，第${count}次重试成功`);
      resolve(res)
    }).catch((err) => {
      if (count >= totalCount) {
        console.log(`请求失败，重试${totalCount}次后，还是失败，错误信息为：${err}`);
        reject(err)
        return
      }
      console.log(`请求失败正在重试，第${count}次重试，错误信息为：${err}`);
      _recursion(promise, resolve, reject, count + 1, totalCount, params)
    })
  })
}

/**
 * @function 请求重试函数
 * @param promise {Promise<any>}
 * @param totalCount {number} 请求次数
 * @param params {object} 请求参数
 * @returns {Promise<any>}
 */
function requestTry(promise, totalCount, params) {
  totalCount = totalCount || 1
  return new Promise((resolve, reject) => {
    let count = 1
    promise(params).then((res) => {
      console.log(`第一次请求成功`);
      resolve(res)
    }).catch((err) => {
      if (count >= totalCount) {
        reject(err)
        return
      }
      _recursion(promise, resolve, reject, count, totalCount, params)
    })
  })
}

export default requestTry